import React, { Component } from 'react'
import { InputNumber } from 'antd'
import Col from 'react-bootstrap/Col'
import '../wallet.css'
import { Row } from 'react-bootstrap'
import { Select, Input, Form, Button, Tooltip } from 'antd'
import { infoRequired } from '../../../utils/validators'
import { connect } from 'react-redux'
import { getConversionBrlBtc } from '../../../redux-flow/actions/wallet_transactions'
import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

const mapStateToProps = state => ({
    userid: state.login.userid,
    conversionSubmit: state.wallet_transactions.conversionSubmit,
    conversionSuccess: state.wallet_transactions.conversionSuccess,
    message: state.wallet_transactions.message,
    cashSuccess: state.wallet_transactions.success
})

const mapDispatchToProps = dispatch => ({
    handleSubmit: (form, userid, price) => e => {
        e.preventDefault()
        dispatch(getConversionBrlBtc(form, userid, price))
    }
})


const Option = Select.Option

const FormConversao = Form.create({ name: 'conversion-btcbrl' })(
    connect(mapStateToProps, mapDispatchToProps)(
        ({ handleSubmit, form, userid, price, valor, onChangeInput, balance, qtBrl, isLoading, currencyFormatter, formatarMoeda, taxa  }) => (
            <Form
                onSubmit={handleSubmit(form, userid, price)}    
            >
                <Row>
                    <Col md={3} className="mt-3">
                    <>
                            <label className='titulosTransferirBtc mt-2 p-0 tx-pink'>Cotação:<Tooltip title="A cotação está sujeita à variação entre o momento de carregamento da página e o de execução da ordem." className="ml-2"><FontAwesomeIcon icon={faInfoCircle} /></Tooltip></label>
                            <div className='divInputValorBtcCotacao'>
                                {/* <label className='titulosTransferirBtc'>BTC</label> */}
                                <label className="tx-blue"><b>R$ {formatarMoeda(price.toFixed(2))}</b></label>
                            </div>
                        </>
                    </Col>
                    <Col md={12}></Col>
                    <Col md={8} className="mt-3">
                        <label className='titulosTransferirBtc mt-3 mb-2 p-0'>Informe o valor</label> 
        
                        <div className='divInputValorBtc'>
                            <label className='moedaBtc'>R$</label>
                            <Form.Item>
                                {form.getFieldDecorator('brl', {
                                    rules: [ infoRequired ]
                                })(
                                    <InputNumber
                                        onKeyUp={(e) => onChangeInput(e)}
                                        className="inputValor"
                                        formatter={value => currencyFormatter(value)}
                                        // min={5000}
                                        // max={100000000}
                                        parser={value => String(value).replace(/\D/g, '')}
                                        style={{ width: '100%' }}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </Col>

                    <Col md={4} className="mt-3">
                        <label className='titulosTransferirBtc p-0 mt-3 tx-pink'>Taxa {process.env.REACT_APP_NAME}:<Tooltip title={`A taxa ${process.env.REACT_APP_NAME} corresponde a 1% do valor da transação`} className="ml-2"><FontAwesomeIcon icon={faInfoCircle} /></Tooltip></label>  
                                                    
                        <div className='divInputValorBtc'>
                            {/* <label className='titulosTransferirBtc'>BTC</label> */}
                            <label className="tx-blue"><b>R$ {formatarMoeda(taxa.toFixed(2))}</b></label>
                        </div>
                    </Col>
                    <Col md={6} className="mt-3">
                        <label className='titulosTransferirBtc mt-3 mb-2 p-0'>Conversão aproximada em bitcoin</label> 
                                                    
                        <div className='divInputValorBtc'>
                            <label className='moedaBtc'>BTC</label>
                                                                
                            <InputNumber
                                className="inputValor"
                                // formatter={value => this.currencyFormatter(value)}
                                max={100000000}
                                // parser={value => String(value).replace(/\D/g, '')}
                                style={{ width: '100%', fontSize: '5px'}}
                                value={valor}
                                disabled={true}
                            />
                        </div>
                    </Col>
                    <Col md={6} className='d-flex flex-column pl-3 mt-3'>
                        <label className='titulosTransferirBtc mt-3 mb-2 p-0'>Confirme sua senha</label> 
                        <div className="divInputValorBtc">
                            <Form.Item>
                                {form.getFieldDecorator('password', {
                                        rules: [ infoRequired ]
                                    })(
                                    <Input type='password' className="inputValor"/>
                                )}
                            </Form.Item>
                        </div>     
                    </Col>
                    <Col md={6} className="mt-5">
                        {qtBrl < 50 && qtBrl !== 0 ? <label style={{color: 'red'}}>O valor de conversão deve ser maior ou igual a R$50,00</label> :
                        <div className="saldoWrapper d-flex flex-column align-items-center">
                            <label className="h6 tx-grey font-weight-bold mb-0">Saldo {balance/100 >= qtBrl ? 'disponível' : 'indisponível'}</label>
                            {isLoading ? <label className="pt-3 pb-3">Realizando transferência</label> :
                            balance/100 >= qtBrl ? 
                                <div> 
                                    <label className="tx-grey mt-3">Deseja efetuar a transação?</label>
                                    <div className="d-flex mt-2">
                                        {/* <Button className="btnSaldo btnNegativo mr-1">Não</Button> */}
                                        <button className="btnSaldo btnPositivo ml-1" style={{ width: '100%' }} disabled={price == '0' && true}>Sim</button>
                                    </div>
                                </div>
                            : '' }
                        </div> }
                    </Col>
                </Row>
            </Form>
        )
    )
)

class BtcBrl extends Component {
    constructor(props) {
    super(props)
    this.state = {
        tabAtiva: 'salvar',
        price: '0',
        priceCount: 0,
        valor: 0,
        qtBrl: 0,
        taxa: 0
        
    }}

    getCotacao = () => {
        var config = {
            method: 'get',
            url: 'https://api3.binance.com/api/v3/ticker/price?symbol=BTCBRL',
            headers: { }
        };
    
        axios(config)
        .then((response) => {
            var rawPrice = parseFloat(response.data.price)
            rawPrice = rawPrice*1.02
            this.setState({
                priceCount: rawPrice
            })
        })
        .catch((error) => {
            console.log(error);
        });
    }

    formatarMoeda = (valor) => {   
        if(valor < 1) {
            valor = valor.replace('.', ',')
        } else {
            valor = valor + '';
            valor = parseInt(valor.replace(/[\D]+/g,''));
            valor = valor + '';
            valor = valor.replace(/([0-9]{2})$/g, ",$1");
            if (valor.length > 6) {
              valor = valor.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
            }
        }
        
        if(valor[0] === ',') {
            valor = 0+valor
        }

        return valor
      }

    componentDidMount() {
        this.getCotacao()
    }

    currencyFormatter = (e) => {
        var tmp = e+'';
        //if(tmp < 5000)  tmp = 5000+''
        //console.log('FORMATTER', tmp)
        tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
        if( tmp.length > 6 )
                tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");

        return tmp;
    }

    onChangeInput = (e) => {
        var value = e.target.value
        if(value[0] === ',') {
            value = 0+value
            value = value.replace(',', '.')
        } else {
            value = value.replace('.', '')
            value = value.replace(',', '.')
        }
        value = Number(value)
        var price = parseFloat(this.state.priceCount)
        var fee = parseFloat(value*0.01)
        this.setState({
            valor: ((value-fee) / price).toFixed(8),
            qtBrl: value,
            taxa: fee
        })
    }

        render() {
            const { conversionSuccess, message } = this.props
            return (
    
                <>
                    <Row className="p-0" >
                        <Col md={12}>
                            {!conversionSuccess && message != null ? 
                                <div class="alert alert-danger text-center" role="alert">
                                    {message}
                                </div> : ''}
                            <FormConversao formatarMoeda={this.formatarMoeda} currencyFormatter={this.currencyFormatter} isLoading={this.props.conversionSubmit} balance={this.props.balance} price={this.state.priceCount} qtBrl={this.state.qtBrl} valor={this.state.valor} onChangeInput={this.onChangeInput} taxa={this.state.taxa} />
                        </Col>
                    </Row>             
                
                </>
            )
        }
    }


    
export default connect(mapStateToProps, mapDispatchToProps)(BtcBrl)